// Keep the public block entry point; headline changes are now user-controlled.
export { default } from "./intro-slide-text-slider";
